<template>
  <div class="content">
    <div class="content-main">
      <p class="content-title">举报管理</p>
      <div class="content-input">
        <div class="content-input-item">
          <el-select v-model="sex" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in sexArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>状态：</label>
          <el-select v-model="state" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in stateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>举报类型：</label>
          <el-select v-model="type" placeholder="Select" style="width: 7.4em">
            <el-option v-for="item in typeArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>举报入口：</label>
          <el-select v-model="model" placeholder="Select" style="width: 7.4em">
            <el-option v-for="item in modelArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>禁言：</label>
          <el-select v-model="bannedChatState" placeholder="Select" style="width: 7.4em">
            <el-option v-for="item in bannedChatStateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>封号：</label>
          <el-select v-model="forbiddenState" placeholder="Select" style="width: 7.4em">
            <el-option v-for="item in forbiddenStateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>设备：</label>
          <el-select v-model="idfaBanState" placeholder="Select" style="width: 7.4em">
            <el-option v-for="item in idfaBanStateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>隐藏：</label>
          <el-select v-model="isDel" placeholder="Select" style="width: 7.4em">
            <el-option v-for="item in isDelArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <DatePickerRange title="创建时间：" @date="getTime($event)" @check="getCheck($event)" :isChecked="isChecked"/>
        </div>
        <div class="content-input-item">
          <el-select v-model="searchSubType" placeholder="Select" style="width: 7em;margin-right: 8px;">
            <el-option v-for="item in searchSubTypeArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
          <SearchComponents :searchValue="searchValue" @searchType="getSearchType($event)" @searchValue="getSearchValue($event)" />
        </div>
        <div class="content-input-item">
          <ElButtons type="primary" icon="search" @click="getPage(true)" v-loading="searchLoading"> 查询 </ElButtons>
          <ElButtons icon="RefreshLeft" @click="refreshParam"> 重置 </ElButtons>
        </div>
      </div>
    </div>
    <div class="content-main">
      <div class="content-button">
        <div>
          <el-button type="primary" v-loading="updateLoading" @click="updateState">已处理</el-button>
          <el-button type="warning" @click="sendMessage(1)">警告被举报人</el-button>
          <el-button type="success" @click="sendMessage(2)">通知举报人</el-button>
          <el-input v-model="searchBillValue" placeholder="请输入订单号" clearable style="width: 20em; margin-left: 16px;"/>
          <el-button style="margin-left: 8px;" type="success" @click="getSearchBill" v-loading="searchBillLoading"> 查询 </el-button>
        </div>
        <BtnGroup :tableRef="$refs.multipleTableRef" :colList="colList" @colListChange="colListChange($event)" @refresh="getPage"></BtnGroup>
      </div>
      <div class="content-table">
        <el-table
            ref="multipleTableRef"
            :data="pageDataList"
            style="width: 100%"
            border
            @cell-click="toggleSelection"
            v-loading="listLoading"
            @selection-change="selsChange"
            @header-click="selsAll"
        >
          <el-table-column type="selection" width="55" align="center" class-name="cursor"/>
          <el-table-column property="createTime" label="时间" v-if="checkColList.indexOf('时间') > -1"/>
<!--          <el-table-column label="举报人" v-if="checkColList.indexOf('举报人') > -1" width="105">-->
<!--            <template #default="scope">-->
<!--              <el-image style="width: 80px; height: 80px" :src="scope.row.resumeInfo.headImg.smallHeadImg" @click="showHeadImg(scope.row.resumeInfo.headImg.headImg)" class="cursor"><template #error><div class="el-img-error">暂无图片</div></template></el-image>-->
<!--            </template>-->
<!--          </el-table-column>-->
          <el-table-column label="举报人" v-if="checkColList.indexOf('举报人') > -1" width="190">
            <template #default="scope">
              <UserInfoList :row="scope.row.resumeInfo" showList="name,phone,uid"/>
            </template>
          </el-table-column>
<!--          <el-table-column label="被举报人" v-if="checkColList.indexOf('被举报人') > -1" width="105">-->
<!--            <template #default="scope">-->
<!--              <el-image style="width: 80px; height: 80px" :src="scope.row.toResumeInfo.headImg.smallHeadImg" @click="showHeadImg(scope.row.toResumeInfo.headImg.headImg)" class="cursor"><template #error><div class="el-img-error">暂无图片</div></template></el-image>-->
<!--            </template>-->
<!--          </el-table-column>-->
          <el-table-column label="被举报人" v-if="checkColList.indexOf('被举报人') > -1" width="190">
            <template #default="scope">
              <UserInfoList :row="scope.row" :userId="scope.row.relUserId" showList="name,phone,uid"/>
            </template>
          </el-table-column>
          <el-table-column label="举报入口" v-if="checkColList.indexOf('举报入口') > -1" width="90">
            <template #default="scope">
              <p>{{scope.row.model == 1?'对方主页':scope.row.model == 3?'动态':scope.row.model == 4?'IM聊天':scope.row.model == 5?'微信二维码':scope.row.model == 6?'小纸条':scope.row.model == 7?'动态评论':''}}</p>
            </template>
          </el-table-column>
          <el-table-column label="举报类型" v-if="checkColList.indexOf('举报类型') > -1" width="90">
            <template #default="scope">
              <p>{{scope.row.type == 0?'其他':scope.row.type == 1?'广告骚扰':scope.row.type == 2?'色情暴力':scope.row.type == 3?'政治/违法':scope.row.type == 4?'身份作假':scope.row.type == 5?'色情暴力、政治违法':scope.row.type == 6?'违规索要/透露微信等联系方式':scope.row.type == 7?'对方微信二维码异常或无法添加':''}}</p>
            </template>
          </el-table-column>
          <el-table-column property="msg" label="描述内容" v-if="checkColList.indexOf('描述内容') > -1" min-width="100"/>
          <el-table-column label="上传截图" v-if="checkColList.indexOf('上传截图') > -1" width="200">
            <template #default="scope">
              <el-space wrap>
                <el-image style="width: 48px; height: 48px" fit="cover" v-for="(item, index) in scope.row.imgList" :key="item.id" :src="item.smallImg" @click="showImg(index, scope.row.imgList)" class="cursor"><template #error><div class="el-img-error">暂无图片</div></template></el-image>
              </el-space>
            </template>
          </el-table-column>
          <el-table-column property="" label="处理结果" v-if="checkColList.indexOf('处理结果') > -1" width="90">
            <template #default="scope">
              <p>{{scope.row.state == 1?'已处理':'未处理'}}</p>
            </template>
          </el-table-column>

          <el-table-column prop="" label="警告通知" class-name="cursor" v-if="checkColList.indexOf('警告通知') > -1" width="90">
            <template #default="scope">
              <p style="color: #3a8ee6">{{scope.row.relWarnMsgNum}}</p>
            </template>
          </el-table-column>
          <el-table-column prop="" label="被举报记录" class-name="cursor" v-if="checkColList.indexOf('被举报记录') > -1" width="100">
            <template #default="scope">
              <p style="color: #3a8ee6">{{scope.row.relReportNum}}</p>
            </template>
          </el-table-column>
          <el-table-column prop="" label="禁言记录" class-name="cursor" v-if="checkColList.indexOf('禁言记录') > -1" width="90">
            <template #default="scope">
              <p style="color: #3a8ee6">{{scope.row.relBannetChatNum}}</p>
            </template>
          </el-table-column>
          <el-table-column prop="" label="微信问题" class-name="cursor" v-if="checkColList.indexOf('微信问题') > -1" width="90">
            <template #default="scope">
              <p style="color: #3a8ee6">{{scope.row.relReportWechatNum}}</p>
            </template>
          </el-table-column>
          <el-table-column prop="" label="处罚状态" v-if="checkColList.indexOf('处罚状态') > -1" width="90">
            <template #default="scope">
              <p v-if="scope.row.isBannedChat">已禁言</p>
              <p v-if="scope.row.isIdfaBan">已冻结</p>
              <p v-if="scope.row.isDel == 1">已隐藏</p>
              <p v-if="scope.row.isForbidden" style="color: red">已封号</p>
              <p v-if="scope.row.wechatState == 3">微信已不通过</p>
            </template>
          </el-table-column>

          <el-table-column property="" label="操作" v-if="checkColList.indexOf('操作') > -1" width="100">
            <template #default="scope">
              <el-button type="danger" size="small" @click="illegalNotice(scope.$index, scope.row)" style="margin-bottom: 6px;">违规通报</el-button>
              <ActionButton :row="scope.row" :userId="scope.row.relUserId" showList="hide,forbidden,chat,point"/>
              <el-button v-if="scope.row.wechatState == 3" type="success" size="small" @click="singlePass(scope.$index,scope.row)" v-loading="scope.row.sPassLoading">通过微信</el-button>
              <el-button v-if="scope.row.wechatState == 2" type="primary" size="small" @click="singleReject(scope.$index, scope.row)">不通过微信</el-button>

            </template>
          </el-table-column>
          <el-table-column label="举报人日志" v-if="checkColList.indexOf('举报人日志') > -1" class-name="cursor" width="180">
            <template #default="scope">
              <UserLog :user-log-list="scope.row.resumeInfo.userLogList" />
            </template>
          </el-table-column>
          <el-table-column label="被举报人日志" v-if="checkColList.indexOf('被举报人日志') > -1" class-name="cursor" width="180">
            <template #default="scope">
              <UserLog :user-log-list="scope.row.userLogList" />
            </template>
          </el-table-column>
        </el-table>
        <el-pagination background layout="total, prev, pager, next, jumper" :total="totalRow" :page-size="pageSize" :current-page="currentPage" @current-change="handleCurrentChange">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import DatePickerRange from '../../components/DatePickerRange'
import SearchComponents from '../../components/SearchComponents'
// import BtnGroup from '../../components/BtnGroup'
import {
  getReportPageList,
  updateReportState,
  batchUpdateWeChatState, getSearchBillInfo
} from '../../api/url'
import { getFormData, postJson, postFormData } from '../../api/api'
import Dialog from '../../assets/js/dialog'
import UserLogDialog from '../../components/UserLog/UserLogDialog'
import ImgViewer from '../../assets/js/imageViewer'
import {common} from "@/assets/shared/select-constant";
import UserLog from "@/components/UserLog/UserLog";
import ActionButton from "@/components/resume/ActionButton";
import WeChatRejectDialog from "@/views/wechat/components/WeChatRejectDialog";
import SendSystemMessageReport from "@/components/SendSystemMessageReport";
import ReportListDialog from "@/views/chat/components/monitor/ReportListDialog";
import WarnListDialog from "@/views/chat/components/monitor/WarnListDialog";
import BannedChatListDialog from "@/views/chat/components/monitor/BannedChatListDialog";
import IllegalSearchInfoDialog from "@/views/feedback/components/IllegalSearchInfoDialog";
import SearchBillInfoDialog from "@/views/vip/components/SearchBillInfoDialog";

export default {
  name: "FeedbackReport",
  components: { DatePickerRange, SearchComponents,UserLog, ActionButton },
  data() {
    return {

      searchSubTypeArray: [
        {label: '被举报人', value: 1},
        {label: '举报人', value: 2},
      ],
      searchSubType: 1,

      sexArray: [
        {label: '不限', value: -1},
        {label: '男', value: 1},
        {label: '女', value: 2},
      ],
      sex: -1,

      stateArray: [
        {label: '不限', value: -1},
        {label: '未处理', value: 0},
        {label: '已处理', value: 1},
      ],
      state: 0,

      typeArray: [
        {label: "不限", value: -1},
        {label: "其他", value: 0},
        {label: "广告骚扰", value: 1},
        {label: "色情暴力", value: 2},
        {label: "政治/违法", value: 3},
        {label: "身份作假", value: 4},
        {label: "色情暴力、政治违法", value: 5},
        {label: "违规索要/透露微信等联系方式", value: 6},
        {label: "对方微信二维码异常或无法添加", value: 7},
      ],
      type: -1,

      //举报入口
      modelArray: [
        {label: "不限", value: -1},
        {label: "IM聊天", value: 4},
        {label: "对方主页", value: 1},
        {label: "小纸条", value: 6},
        {label: "动态", value: 3},
        {label: "动态评论", value: 7},
        {label: "微信二维码", value: 5},
      ],
      model: -1,

      isDelArray: common.showStateList,
      isDel: common.showStateList[0]['value'],

      forbiddenStateArray: common.forbiddenStateList,
      forbiddenState: common.forbiddenStateList[0]['value'],

      bannedChatStateArray: common.bannedChatStateList,
      bannedChatState: common.bannedChatStateList[0]['value'],

      idfaBanStateArray: common.idfaBanStateList,
      idfaBanState: common.idfaBanStateList[0]['value'],

      //时间
      startTime: '',
      endTime: '',
      isChecked: true,

      //搜索
      searchType: '',
      searchValue: '',

      //刷新组
      colList: ['时间', '举报人', '被举报人', '举报入口', '举报类型','描述内容', '上传截图', '处理结果', '警告通知', '被举报记录', '禁言记录', '微信问题', '处罚状态', '操作', '举报人日志', '被举报人日志'],
      checkColList: [],

      pageDataList: [],
      currentPage: 1,
      totalRow: 0,
      pageSize: 20,
      listLoading: false,
      searchLoading: false,
      updateLoading: false,

      //选中id
      idArray: [],
      userIdArray: [],
      toUserIdArray: [],

      //查询订单号
      searchBillValue: '',
      searchBillLoading: false,

    }
  },
  methods: {
    getTime(val) {
      this.startTime = val[0];
      this.endTime = val[1];
      // console.log(val)
    },
    getCheck(val) {
      this.isChecked = val
    },
    getSearchType(e) {
      this.searchType = e;
      // console.log(e)
    },
    getSearchValue(e) {
      this.searchValue = e;
      // console.log(e)
    },
    // 展示表格的列
    colListChange(val) {
      this.checkColList = val;
    },
    // 重置参数
    refreshParam() {
      this.isChecked = true;
      this.searchSubType = 1;
      this.sex = -1;
      this.state = 0;
      this.type = -1;
      this.model = -1;
      this.isDel = -1;
      this.forbiddenState = -1;
      this.bannedChatState = -1;
      this.idfaBanState = -1;
      this.searchValue = '';
      setTimeout(()=> {
        this.getPage(true);
      }, 500)
    },
    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },

    //获取选中id
    selsChange(sels) {
      this.idArray = sels.map(item => item.id);
      this.userIdArray = sels.map(item => item.userId);
      this.toUserIdArray = sels.map(item => item.relUserId);
    },

    //全选
    selsAll(column, event) {
      if(column.type == 'selection') {
        let array = this.idArray;
        if(array.length == this.pageDataList.length) {
          array = [];
        }
        this.pageDataList.forEach(item => {
          if(array.indexOf(item.id) === -1) {
            this.$refs.multipleTableRef.toggleRowSelection(item);
          }
        })
      }
    },

    getPage(reset) {
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        if(reset) {
          this.currentPage = 1;
        }
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      param['pageNum'] = page;
      param['sex'] = this.sex;
      param['type'] = this.type;
      param['state'] = this.state;
      param['model'] = this.model;
      param['forbiddenState'] = this.forbiddenState;
      param['isDel'] = this.isDel;
      param['bannedChatState'] = this.bannedChatState;
      param['idfaBanState'] = this.idfaBanState;
      param['startTime'] = this.startTime;
      param['endTime'] = this.endTime;
      param['searchType'] = this.searchType;
      param['searchSubType'] = this.searchSubType;
      param['searchValue'] = this.searchValue;
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(getReportPageList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result['records'];
          this.totalRow = result['total'];
          this.pageSize = result['size'];
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch((response) => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },


    //处理状态
    updateState() {
      if(this.idArray.length > 0) {
        this.$confirm('确认批量处理为【已处理】').then(()=>{
          this.updateLoading = true;
          let _this = this;
          let param = {};
          param['idArr'] = this.idArray;
          param['state'] = 1;
          postFormData(updateReportState, param).then((data) => {
            let {code, msg} = data;
            if(code == 200) {
              _this.$message({
                showClose: true,
                duration: 1000,
                message: msg,
                type: 'success'
              });
              for(let j=0;j<_this.idArray.length;j++){
                for(let i=0;i<_this.pageDataList.length;i++) {
                  if(_this.pageDataList[i]['id'] == _this.idArray[j]) {
                    _this.pageDataList.splice(i,1);
                    i--;
                  }
                }
              }
              if(_this.pageDataList.length == 0){
                _this.getPage();
              }
            }else {
              _this.$message({
                showClose: true,
                duration: 1000,
                message: msg,
                type: 'warning'
              });
            }
            _this.updateLoading = false;
          })
              .catch(()=>{
                _this.updateLoading = false;
              })
        })
      }else {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请至少选择一条记录进行操作',
          type: 'warning'
        })
      }
    },

    //封号
    updateForbidState(idx, row, state) {
      this.$confirm('确定对被举报人【' + row.toResumeInfo.nickName + '】' + (state == 1?'封号？':'解除封号？')).then(()=>{
        this.pageDataList[idx].forbidLoading = true
        let _this = this;
        let param = {};
        param['ids'] = row.toResumeInfo.userId;
        param['forbiddenState'] = state;
        postFormData(updateForbiddenState, param).then((data) => {
          let {code, msg} = data;
          if(code == 200) {
            _this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'success'
            });
            _this.getPage()
          }else {
            _this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'warning'
            });
          }
          _this.pageDataList[idx].forbidLoading = false;
        })
            .catch(()=>{
              _this.pageDataList[idx].forbidLoading = false;
            })
      })
    },

    //隐藏
    updateHideState(idx, row, state) {
      this.$confirm('确定对被举报人【' + row.toResumeInfo.nickName + '】' + (state == 1?'隐藏？':'解除隐藏？')).then(()=>{
        this.pageDataList[idx].hideLoading = true
        let _this = this;
        let param = {};
        param['ids'] = row.toResumeInfo.userId;
        param['showState'] = state;
        postFormData(updateShowState, param).then((data) => {
          let {code, msg} = data;
          if(code == 200) {
            _this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'success'
            });
            _this.getPage()
          }else {
            _this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'warning'
            });
          }
          _this.pageDataList[idx].hideLoading = false;
        })
            .catch(()=>{
              _this.pageDataList[idx].hideLoading = false;
            })
      })
    },

    //图片预览
    showHeadImg(img) {
      let imgList = []
      imgList.push(img)
      ImgViewer.open({
        imgList
      })
    },

    showImg(idx, list) {
      let imgList = []
      for(let i=0; i< list.length; i++) {
        imgList.push(list[i].img)
      }
      ImgViewer.open({
        imgList,
        imgIndex: idx
      })
    },

    toggleSelection(row, column, cell, event) {

      if(column.type == 'selection') {
        this.$refs.multipleTableRef.toggleRowSelection(row)
      }

      //更新用户日志
      if(column.label == '举报人日志') {
        Dialog.open({
          title: '用户日志',
          component: UserLogDialog,
          data: {
            id: row.userId
          },
          close: () => {
            row['user_log'] = JSON.parse(sessionStorage.getItem('userLog'));
          }
        })
      }
      if(column.label == '被举报人日志') {
        Dialog.open({
          title: '用户日志',
          component: UserLogDialog,
          data: {
            id: row.relUserId
          },
          close: () => {
            row['user_log'] = JSON.parse(sessionStorage.getItem('userLog'));
          }
        })
      }

      if(column.label == '被举报记录') {
        Dialog.open({
          title: row.nickName + '的被举报记录',
          component: ReportListDialog,
          data: {
            id: row.relUserId,
            width: '800px'
          }
        })
      }

      if(column.label == '微信问题') {
        Dialog.open({
          title: row.nickName + '的微信问题',
          component: ReportListDialog,
          data: {
            id: row.relUserId,
            type: 7,
            width: '900px'
          }
        })
      }

      if(column.label == '警告通知') {
        Dialog.open({
          title: row.nickName + '的警告通知',
          component: WarnListDialog,
          data: {
            id: row.relUserId,
            width: '800px'
          }
        })
      }

      if(column.label == '禁言记录') {
        Dialog.open({
          title: row.nickName + '的禁言记录',
          component: BannedChatListDialog,
          data: {
            id: row.relUserId,
            width: '800px'
          }
        })
      }

    },

    sendMessage(to) {
      if(this.idArray.length == 0) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请至少选择一条记录进行操作',
          type: 'warning'
        })
        return false
      }
      let _title = '';
      if(to == 1) {
        _title = '给被举报人发送通知'
      }
      if(to == 2) {
        _title = '给举报人发送通知'
      }
      Dialog.open({
        title: _title,
        component: SendSystemMessageReport,
        data: {
          idArray: this.idArray,
          userIdArray: this.userIdArray,
          toUserIdArray: this.toUserIdArray,
          to: to,
          width: '700px'
        },
        confirm: ()=> {
          for(let j=0;j<this.idArray.length;j++){
            for(let i=0;i<this.pageDataList.length;i++) {
              if(this.pageDataList[i]['id'] == this.idArray[j]) {
                this.pageDataList.splice(i,1);
                i--;
              }
            }
          }
          if(this.pageDataList.length == 0){
            this.getPage();
          }
        }
      })
    },

    //微信单个通过
    singlePass(idx, row) {
      this.$confirm('确认通过用户【'+ row.nickName +'】？').then(() => {
        row.sPassLoading = true;
        let idArr = []
        idArr.push(row.relUserId)
        let _this = this;
        let param = {};
        param['idArr'] = idArr;
        param['state'] = 2;
        param['imMsg'] = '';
        postFormData(batchUpdateWeChatState,param).then(function(data){
          let {code,msg} = data;
          if(code == 200){
            _this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'success'
            });
            row['wechatState'] = 2
          }else{
            _this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'warning'
            })
          }
          row.sPassLoading = false;
        })
            .catch(function(){
              row.sPassLoading = false;
            })
      })
          .catch(() => {})
    },

    //微信单个拒绝
    singleReject(idx, row) {
      let idArr = []
      idArr.push(row.relUserId)
      Dialog.open({
        title: '发送不通过【'+ row.nickName +'】的原因',
        component: WeChatRejectDialog,
        data: {
          ids: idArr,
          width: '500px'
        },
        confirm: () => {
          row['wechatState'] = 3
        }
      })
    },

    //违规通报
    illegalNotice(idx, row) {
      // console.log(e)
      let resumeForm = Object.assign({}, row)
      resumeForm.userId = resumeForm.relUserId
      Dialog.open({
        component: IllegalSearchInfoDialog,
        data: {
          userForm: resumeForm,
          idx: -1,
          width: '600px'
        },
        confirm: () => {
          // this.pageDataList.splice(idx,1);
        }
      })
    },

    getSearchBill() {
      if(!this.searchBillValue) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '订单号不能为空',
          type: 'warning'
        });
        return;
      }
      this.searchBillLoading = true
      let param = {};
      param['searchValue'] = this.searchBillValue;
      getFormData(getSearchBillInfo, param).then((data)=> {
        let {code, msg} = data;
        if (code == 200) {
          // console.log(data)
          Dialog.open({
            component: SearchBillInfoDialog,
            data: {
              userForm: data.data,
              width: '600px'
            },
            confirm: () => {
              // this.getPage()
            }
          })
        } else {
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchBillLoading = false
      })
    }


  },
  mounted() {
    this.$nextTick(function() {
      this.checkColList = this.colList;
    })
    this.getPage();
  }
}
</script>

<style scoped>

</style>
